import { boot } from 'quasar/wrappers'
import aiTranslate from 'src/directives/aiTranslate'

// Optional: plug a fallback here (backend/libretranslate/etc)
import { setFallbackBatchTranslator } from 'src/services/aiTranslator'

export default boot(({ app }) => {
  app.directive('ai-translate', aiTranslate)

  // Example fallback (DISABLED by default):
  // setFallbackBatchTranslator(async ({ texts, from, to }) => {
  //   const res = await fetch('/api/translate', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ texts, from, to })
  //   })
  //   if (!res.ok) throw new Error('Fallback translate failed')
  //   const data = await res.json()
  //   return data.translations
  // })
})
